import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { MdSidenav, MdDialog, MdDialogRef, MdIconRegistry } from '@angular/material';
import { AuthService, ScrollService, UserService, TooltipService, SearchService,SongsService } from './api/';
import { ChangePasswordComponent } from './index';
// import { ScrollSpyService } from 'ng2-scrollspy';
import { Globals } from './app.globals';
import { PlayerService } from './player/services/player.service';
import { DomSanitizer } from '@angular/platform-browser';
import '../../node_modules/chart.js';
import { CartService } from './api';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import 'intl';
import 'intl/locale-data/jsonp/en';
declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit {
  @ViewChild('sidenav') sidenav: MdSidenav;
  @ViewChild('end') end: MdSidenav;
  @ViewChild('appcontent') scrollDiv: ElementRef;
  dialogRef2: MdDialogRef<WelcomDialogComponent>;
  dialogRef: MdDialogRef<ChangePasswordComponent>;
  checkIfMobile: boolean = true;
  checkIfMobile2: boolean = false;
  sideOver: boolean = false;
  private collapse = [false, false, false];
  private data: any = '';
  private check: any = '';
  public menu: any = '';
  @BlockUI() blockUI: NgBlockUI;
  currentDate: any = '';
  currentYear: any = '';
  private viewAsList = 1;
  private searchTerm: string = '';
  lasthieht:any = 0;
  lastUrl:any = "";
  scrollCount:any = 0;
  startDate:any = (new Date).toTimeString().slice(0,8);
  endDate:any = '';
  lastInteraction:any = 0;
  public onlineOffline: boolean = navigator.onLine;
  firstOnlinecheck: any ;
  package:any = 0;

  constructor(private songsService: SongsService,private authService: AuthService,private route: ActivatedRoute, private scrollService: ScrollService, private router: Router, private scrollBroadcastService: ScrollService,
  public dialog: MdDialog, private userService: UserService, tooltipService: TooltipService, private playerService: PlayerService,
  private mdIconRegistry: MdIconRegistry, private sanitizer: DomSanitizer, private searchService: SearchService, private cartService: CartService, ) {
    window.addEventListener('online', () => {this.onlineOffline = true;
      this.firstOnlinecheck = true;
      setTimeout(()=>{
        document.getElementById("intId").style.display = 'none';
      },7500)
    });
    window.addEventListener('offline', () => {this.onlineOffline = false;
      this.firstOnlinecheck = false;
    });

    this.logVisitor();

    this.menu = {
      "section1": [  {
        "id": "1",
        "title": "Global Discoveries",
        "link": "/global-discoveries",
        "icon": "/assets/icons/DISCOVERY.svg",
        "menu_id": "1",
        "sort_order": "2"
      }, {
        "id": "3",
        "title": "WeGet Official",
        "link": "/weget-official",
        "icon": "/assets/icons/WEGET_FAVORITES.svg",
        "menu_id": "1",
        "sort_order": "3"
      }, {
        "id": "10",
        "title": "Time Period",
        "link": "/time-period",
        "icon": "/assets/icons/PLAYLISTS_ICON_BLUE.svg",
        "menu_id": "1",
        "sort_order": "9"
      },{
        "id": "9",
        "title": "Composers",
        "link": "/composers",
        "icon": "/assets/icons/MUSIC_FOR_MOVIES.svg",
        "menu_id": "1",
        "sort_order": "8"
      }, {
        "id": "8",
        "title": "Newest Music",
        "link": "/newest-music",
        "icon": "/assets/icons/NEWEST_MUSIC.svg",
        "menu_id": "1",
        "sort_order": "7"
      }, {
        "id": "5",
        "title": "Most Played",
        "link": "/most-played",
        "icon": "/assets/icons/MOST_PLAYED.svg",
        "menu_id": "1",
        "sort_order": "4"
      }, {
        "id": "6",
        "title": "Most Downloaded",
        "link": "/most-downloaded",
        "icon": "/assets/icons/MOST_DOWNLOADED.svg",
        "menu_id": "1",
        "sort_order": "5"
      }, {
        "id": "7",
        "title": "Recent Licenses",
        "link": "/recent-licenses",
        "icon": "/assets/icons/MOST_LICENSED.svg",
        "menu_id": "1",
        "sort_order": "6"
      }, {
        "id": "2",
        "title": "Production Credits Search",
        "link": "/advanced-search",
        "icon": "/assets/icons/ADVANCED_SEARCH.svg",
        "menu_id": "1",
        "sort_order": "1"
      }],
      "section2": [ {
        "id": "13",
        "title": "Genre Playlists",
        "link": "/genres-playlists",
        "icon": "/assets/icons/PLAYLISTS_ICON_ORANGE.svg",
        "menu_id": "2",
        "sort_order": "12"
      },{
        "id": "11",
        "title": "Fans Playlists",
        "link": "/fans-playlists",
        "icon": "/assets/icons/PLAYLISTS_ICON_ORANGE.svg",
        "menu_id": "2",
        "sort_order": "10"
      }, {
        "id": "10",
        "title": "Activity Playlists",
        "link": "/activities-playlists",
        "icon": "/assets/icons/PLAYLISTS_ICON_ORANGE.svg",
        "menu_id": "2",
        "sort_order": "9"
      }, {
        "id": "12",
        "title": "Business Playlists",
        "link": "/business-playlists",
        "icon": "/assets/icons/PLAYLISTS_ICON_ORANGE.svg",
        "menu_id": "2",
        "sort_order": "11"
      }, {
        "id": "14",
        "title": "Industry Playlists",
        "link": "/industry-playlists",
        "icon": "/assets/icons/PLAYLISTS_ICON_ORANGE.svg",
        "menu_id": "2",
        "sort_order": "13"
      }, {
        "id": "16",
        "title": "In Memory Playlists",
        "link": "/in-memory-playlists",
        "icon": "/assets/icons/PLAYLISTS_ICON_ORANGE.svg",
        "menu_id": "2",
        "sort_order": "15"
      },{
        "id": "16",
        "title": "Giving Playlists",
        "link": "/giving-playlists",
        "icon": "/assets/icons/PLAYLISTS_ICON_ORANGE.svg",
        "menu_id": "2",
        "sort_order": "15"
      },
      {
        "id": "15",
        "title": "Musicsupervisor Playlists",
        "link": "/musicsupervisor",
        "icon": "/assets/icons/PLAYLISTS_ICON_ORANGE.svg",
        "menu_id": "2",
        "sort_order": "14"
      },
      {
        "id": "15",
        "title": "Official Soundtracks",
        "link": "/official-soundtracks",
        "icon": "/assets/icons/PLAYLISTS_ICON_ORANGE.svg",
        "menu_id": "2",
        "sort_order": "14"
      }, {
        "id": "16",
        "title": "Podcasts",
        "link": "/podcasts",
        "icon": "/assets/icons/PLAYLISTS_ICON_ORANGE.svg",
        "menu_id": "2",
        "sort_order": "15"
      }, {
        "id": "16",
        "title": "Gamers Playlists",
        "link": "/gamers",
        "icon": "/assets/icons/PLAYLISTS_ICON_ORANGE.svg",
        "menu_id": "2",
        "sort_order": "15"
      }, {
        "id": "16",
        "title": "Audio Books",
        "link": "/books",
        "icon": "/assets/icons/PLAYLISTS_ICON_ORANGE.svg",
        "menu_id": "2",
        "sort_order": "15"
      }],
      "section3": [{
        "id": "17",
        "title": "Discoveries",
        "link": "/my-discoveries",
        "icon": "/assets/icons/MY_DISCOVERIES.svg",
        "menu_id": "3",
        "sort_order": "16"
      }, {
        "id": "18",
        "title": "Playlists",
        "link": "/playlists",
        "icon": "/assets/icons/MY_PLAYLISTS.svg",
        "menu_id": "3",
        "sort_order": "17"
      }, {
        "id": "19",
        "title": "Music Collection",
        "link": "/my-music-library",
        "icon": "/assets/icons/MY_MUSIC_COLLECTION.svg",
        "menu_id": "3",
        "sort_order": "18"
      }, {
        "id": "20",
        "title": "Radio",
        "link": "/my-radio",
        "icon": "/assets/icons/RADIO_GREEN.svg",
        "menu_id": "3",
        "sort_order": "19"
      }, {
        "id": "21",
        "title": "Listening",
        "link": "/listening",
        "icon": "/assets/icons/MY_PLAYLISTS.svg",
        "menu_id": "3",
        "sort_order": "20"
      }, {
        "id": "22",
        "title": "Downloads",
        "link": "/dashboard/my-downloads",
        "icon": "/assets/icons/green_downloads.svg",
        "menu_id": "3",
        "sort_order": "21"
      }]
    };

    this.addIconToMdIconRegistry(this.menu.section1);
    this.addIconToMdIconRegistry(this.menu.section2);
    this.addIconToMdIconRegistry(this.menu.section3);

    if (screen.width <= 770) {
      this.sideOver = true;
    }
    if (screen.width <= 668) {
      this.checkIfMobile = false;
      this.checkIfMobile2 = true;
      // if (screen.width > 320 && window.location.pathname.includes('.html') == false) {
      //   this.dialogRef2 = this.dialog.open(WelcomDialogComponent, {
      //     disableClose: false,
      //     width: '80%'
      //   });
      // }
      // if (screen.width <= 320 && window.location.pathname.includes('.html') == false) {
      //   this.dialogRef2 = this.dialog.open(WelcomDialogComponent, {
      //     disableClose: false,
      //     width: '50%',
      //   });
      // }
    }
    this.authService.checkDefaultPackage.subscribe(res => {
      if(res == true) {
        this.checkDefaultPackage();
      }
    });
  }

  closeMenu1() {
    this.playerService.closeMenu();
  }

  ngOnInit() {

    if (localStorage.getItem("viewAsList") == "1") {
      this.viewAsList = 1;
    }
    if (localStorage.getItem("viewAsList") == "2") {
      this.viewAsList = 2;
    }
    if (localStorage.getItem("viewAsList") == "3") {
      this.viewAsList = 3;
    }

    //Mange the menu section 3 base on the user package
    this.checkDefaultPackage();

    if (!!localStorage.getItem('username')) {
      this.data = new Globals().apiEndpoint + 'api/user-avatar?id=' + localStorage.getItem('username');
    }

    this.sidenav._onTransitionEnd = function () {
      this._openPromise = null;
      this._closePromise = null;
    };

    this.addIconToMdIconRegistry('/assets/icons/ic_search_white_24px.svg');
    this.addIconToMdIconRegistry('/assets/icons/ic_cached_white_18px.svg');
    this.addIconToMdIconRegistry('/assets/icons/ic_assignment_black_24px.svg');
    this.addIconToMdIconRegistry('/assets/icons/ic_trending_flat_white_48px.svg');
    this.addIconToMdIconRegistry('/assets/icons/ADD_TO_DISCOVERIES_WHITE.svg');
    this.addIconToMdIconRegistry('/assets/icons/ADD_TO_PLAYLIST_WHITE.svg');
    this.addIconToMdIconRegistry('/assets/icons/ic_close_24px.svg');
    this.addIconToMdIconRegistry('/assets/icons/ic_trending_flat_white_48px.svg');
    this.addIconToMdIconRegistry('/assets/icons/menu.svg');
    this.addIconToMdIconRegistry('/assets/icons/artist.svg');
    this.addIconToMdIconRegistry('/assets/icons/music-note.svg');
    this.addIconToMdIconRegistry('/assets/icons/new/MY_COLLECTION.svg');
    this.addIconToMdIconRegistry('/assets/icons/new/LIKE.svg');
    this.addIconToMdIconRegistry('/assets/icons/cart_primary.svg');
    this.addIconToMdIconRegistry('/assets/icons/new/PLAY.svg');
    this.addIconToMdIconRegistry('/assets/icons/new/PAUSE.svg');
    this.currentDate = new Date();
    this.currentYear = this.currentDate.getFullYear();
  }

  //to check if the package is default
  checkDefaultPackage() {
    if (this.authService.isUserLoggedIn()) {
      this.package = localStorage.getItem("package");
      console.log("package => "+ this.package);
      if(this.package == 5) {
        this.menu.section3.forEach((element, index) => {
          if(element.id == 21 && index == 4) {
            this.menu.section3.splice(index,1);
          }
        });
      } else {
        if(this.menu.section3[4].id != 21) {
          this.menu.section3 = [{
            "id": "17",
            "title": "Discoveries",
            "link": "/my-discoveries",
            "icon": "/assets/icons/MY_DISCOVERIES.svg",
            "menu_id": "3",
            "sort_order": "16"
          }, {
              "id": "18",
              "title": "Playlists",
              "link": "/playlists",
              "icon": "/assets/icons/MY_PLAYLISTS.svg",
              "menu_id": "3",
              "sort_order": "17"
          }, {
              "id": "19",
              "title": "Music Collection",
              "link": "/my-music-library",
              "icon": "/assets/icons/MY_MUSIC_COLLECTION.svg",
              "menu_id": "3",
              "sort_order": "18"
          }, {
              "id": "20",
              "title": "Radio",
              "link": "/my-radio",
              "icon": "/assets/icons/RADIO_GREEN.svg",
              "menu_id": "3",
              "sort_order": "19"
          }, {
              "id": "21",
              "title": "Listening",
              "link": "/listening",
              "icon": "/assets/icons/MY_PLAYLISTS.svg",
              "menu_id": "3",
              "sort_order": "20"
          }, {
              "id": "22",
              "title": "Downloads",
              "link": "/dashboard/my-downloads",
              "icon": "/assets/icons/green_downloads.svg",
              "menu_id": "3",
              "sort_order": "21"
          }];
          this.addIconToMdIconRegistry(this.menu.section3);
        }
      }
    }
  }

  logVisitor() {
    this.userService.visitor().subscribe((res) => {
    });
  }

  ngAfterViewInit() {

    // this.scrollSpyService.getObservable('appcontent').subscribe((e: any) => {

    //   if ((this.scrollDiv.nativeElement.scrollHeight != this.scrollDiv.nativeElement.offsetHeight) && (this.scrollDiv.nativeElement.scrollHeight -
    //     (this.scrollDiv.nativeElement.scrollTop + this.scrollDiv.nativeElement.offsetHeight)) <= 0) {
    //     let event = {
    //       scrollHeight: this.scrollDiv.nativeElement.scrollHeight,
    //       scrollTop: this.scrollDiv.nativeElement.scrollTop,
    //       offsetHeight: this.scrollDiv.nativeElement.offsetHeight
    //     };
    //     if(this.lastUrl!=this.router.url){

    //         this.lastUrl=this.router.url;
    //         this.lasthieht=0;
    //         this.scrollCount=0;
    //         this.lastInteraction=0;
    //         this.startDate=(new Date).toTimeString().slice(0,8);
    //     }
    //     if(this.scrollDiv.nativeElement.scrollHeight-this.lasthieht>60){
    //         this.endDate=(new Date).toTimeString().slice(0,8);
    //         this.lasthieht=this.scrollDiv.nativeElement.scrollHeight;
    //         this.scrollCount++;
    //         this.logInteraction();
    //     }

    //     this.scrollBroadcastService.broadcastScrollEvent(event);
    //   }
    // });

    this.scrollBroadcastService.openRightSideNav.subscribe((event) => {
      if (event.type === 'close') {
        this.end.close();
          var mainUi = document.getElementById("Ui1234");
          if(mainUi) {
            mainUi.style.visibility = "visible";
          }
      } else {
        this.end.open();
      }

    });
  }

  logInteraction() {
    let params = {
      url: this.lastUrl,
      scroll: this.scrollCount,
      start_at: this.startDate,
      end_at: this.endDate,
      id: this.lastInteraction
    };
    this.songsService.interactionLogging(params).subscribe((res) => {
      if(res) {
        this.lastInteraction=res;
      }
    });
  }

  onClose(){
    var mainUi = document.getElementById("Ui1234");
    if(mainUi) {
      mainUi.style.visibility = "visible";
    }
  }

  openChangePassword() {
    this.dialogRef = this.dialog.open(ChangePasswordComponent, {
      disableClose: false,
      width: '520px'
    });
  }

  openSideNav(type: string) {
    this.scrollBroadcastService.openSideNav(type);
  }

  deleteProduct() {
    this.cartService.flushCart();
  }

  signOut() {
    this.deleteProduct();
    this.authService.logOut();
    this.userService.getUserEventEmitter().emit({ 'name': 'user:logout' });
    localStorage.clear();
    this.router.navigate(['/login'], { queryParams: { checkIfTrue: true } });
  }

  addIconToMdIconRegistry(svgSrc: any) {
    if (this.isArray(svgSrc)) {
      svgSrc.forEach((arrayItem) => {
        if (arrayItem.icon && arrayItem.link) {
          this.mdIconRegistry.addSvgIcon(arrayItem.link.replace('/', ''), this.sanitizer.bypassSecurityTrustResourceUrl(arrayItem.icon));
          arrayItem.icon = arrayItem.link.replace('/', '');
        }
      });
    } else {
      let svgName = svgSrc.split('/');
      svgName = svgName[svgName.length - 1].trim();
      this.mdIconRegistry.addSvgIcon(svgName, this.sanitizer.bypassSecurityTrustResourceUrl(svgSrc));
    }

  }

  isArray(myArray) {
    return myArray.constructor.toString().indexOf("Array") > -1;
  }
}

@Component({
  selector: 'welcom-dialog',
  template: `
  <md-toolbar color="primary">
  <span>{{ title }}</span>
  <span class="demo-fill-remaining"></span>
  <span>
    <a>
      <md-icon svgIcon="ic_close_24px.svg" (click)="dialogRef.close()" mdTooltip="{{ 'CLOSE' | tooltip }} " mdTooltipPosition="above"> </md-icon>
    </a>
  </span>
</md-toolbar>
<div class="modal-content">
  <div *ngIf="!smallMobile" fxLayout='row' >
    {{ message }}
  </div>
  <div *ngIf="smallMobile" fxLayout='row' style="font-size:11px;">
    {{ message }}
  </div>
  <div fxLayout='row' style='margin: 10px;text-align: right;'>
    <div fxFlex='100'>
      <button md-raised-button color="primary" (click)='navigate()'>Close</button>
    </div>
  </div>
</div>
`, styles: ['']
})

export class WelcomDialogComponent {
  public title: string = 'Welcome';
  public smallMobile: boolean = false;
  public message: string = "Thank you for trying out the new WeGetMusic site. It's early in our rollout process, and we've focused design efforts on the HTML5 browser implementation. Some mobile platforms offer full functionality, but many do not, based on the hardware platform, software update levels, and the browser being used. We will be supporting all modern mobile devices in the future, via browser and native apps, but in the meantime, if our system treats your mobile device poorly, please accept our apologies, send us a support note, and allow us a future chance to prove that this is the music site you've always wanted.";

  constructor(public dialogRef: MdDialogRef<any>) {
    if (screen.width <= 320) {
      this.smallMobile = true;
    }
  }

  navigate() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts